import React from 'react';

const listTutorials =  [
    {title: "Course video"}
]

const Tutorial = ({params}) => (
<div className="content" id ="content">
        <div className="panel-center">

            <div className="card">
              <div className="card-header">
                <p className="ar">[ Cybersecurity course ]</p>
              </div>
              <div className="card-body">
                <p>:كورس أساسيات الأمن السيبراني  </p>
                <p>
                    Security Principles, Business Continuity (BC), Disaster Recovery (DR) & Incident Response Concepts ,Access Control Concepts, Network Security , Security Operations 
                </p>
                <br />
                <iframe width="560" height="315" src="https://www.youtube.com/embed/GToeg2mkiIQ?si=wZeo-chhuB8XvaxQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <p className="ar">[ Python course ]</p>
              </div>
              <div className="card-body">
                <p>:كورس أساسيات البرمجة البايثون </p>
                <br/>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/SLyowqqblj4?si=Fr3Joizt4KVGsexA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                {/* <h3>جاري العمل عليه</h3> */}
              </div>
            </div>


          </div>

        <div className="panel-right">

        </div>
        <div className="panel-left">
          <div className="card">

          </div>
        </div>
      </div>
);

export default Tutorial;
